// import React, { useEffect, useState } from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useDispatch } from "react-redux";
// import {
//   changeJobApplicationStatus,
//   getApplicantHistory,
//   getApplicationStatusHistory,
//   getOfferLetter,
// } from "../../../../Redux/Reducers/JobReducer";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import { useSelector } from "react-redux";
// import OkModal from "./okModal";
// import ConfirmationModal from "./ConfirmationModal";
// import { useNavigate } from "react-router-dom";

// const ApplicationTrackerforApplicant = ({ applicant, textColor = "gray" }) => {
//   const dispatch = useDispatch();
//   const [statusModal, setStatusModal] = useState(false);
//   const [confirmModal, setConfirmModal] = useState(false);
//   const [visible, setVisible] = useState(false);
//   const [title, setTitle] = useState("");
//   const [message, setMessage] = useState("");
//   const [nextStatus, setNextStatus] = useState("");
//   const [localStatus, setLocalStatus] = useState(applicant?.application_status);
//   const history = useSelector((state) => state?.jobs?.applicationStatusHistory) || [];
//   const ApplicantsPage = useSelector((state) => state?.jobs?.appliedJobs) || [];
//   const applicantHistroy = ApplicantsPage?.appliedJobs;
//   const offerLetters = useSelector((state) => state?.jobs?.OfferLetters) || [];
//   const navigate = useNavigate();
//   console.log("applicantHistroy", applicantHistroy)

//   useEffect(() => {
//     setLocalStatus(applicant?.application_status);

//     // dispatch(getApplicantHistory());
//     // if (applicant?.id) {
//     //   dispatch(getApplicationStatusHistory({ id: applicant.id }));
//     // }
//   }, [applicant?.application_status]);

//   // useEffect(() => {
//   //   dispatch(getApplicantHistory());
//   //   if (applicant?.id) {
//   //     dispatch(getApplicationStatusHistory({ id: applicant.id }));
//   //   }
//   // }, [dispatch, applicant?.id])

//   // const currentStatus = applicant?.application_status;
//   const currentStatus = localStatus;

//   //   console.log("currentStatus", currentStatus)

//   //   useEffect(() => {
//   //     if (applicant?.application_id) {
//   //       dispatch(getApplicationStatusHistory({ id: applicant?.application_id }));
//   //     }
//   //   }, [applicant, currentStatus]);

//   const steps = [
//     { step: "In Review", status: "Shortlisted", done: "Shortlisted" },
//     {
//       step: "Interview", // Removed trailing space
//       status: "Selected",
//       done: "Interviewed", // Changed from "Interviewed" to "Selected"
//       intermediateStatuses: ["Interview In-Progress"], // Added intermediate status
//     },
//     {
//       step: "Offer",
//       status: "Offer Accepted",
//       done: "Offer Accepted",
//       intermediateStates: ["Offer Released", "Offer Revised", "Offer Re-released"],
//     },
//     {
//       step: "Documents",
//       status: "Document Verification",
//       done: "Document Verified",
//       intermediateStates: ["Document Rejected"],
//     },
//     { step: "Join", status: "Joined", done: "Joined" },
//   ];

//   const allPositiveStatus = [
//     "In Review",
//     "Shortlisted",
//     "Interview In-Progress",
//     "Selected",
//     "Offer Released",
//     "Offer Revised",
//     "Offer Re-released",
//     "Offer Accepted",
//     "Document Verification",
//     "Document Verified",
//     "Joined",
//   ];

//   const isStepDone = (stepStatus) => {
//     if (!applicantHistroy?.length) return false;

//     const currentApplication = applicantHistroy.find(
//       (app) => app.id === applicant.id
//     );
//     if (!currentApplication) return false;

//     // Treat a Rejected status after Interview as having completed Shortlist
//     if (currentApplication.application_status === "Rejected" && stepStatus === "Shortlisted") {
//       return true;
//     }

//     // Handle Document Rejected - treat as completed if verification was done
//     if (currentApplication.application_status === "Document Rejected" &&
//       (stepStatus === "Document Verification" || stepStatus === "Document Verified")) {
//       return true;
//     }

//     const stepIndex = allPositiveStatus.indexOf(stepStatus);
//     const currentStatusIndex = allPositiveStatus.indexOf(
//       currentApplication.application_status
//     );

//     return stepIndex <= currentStatusIndex;
//   };


//   const getStep = (step) => {
//     const stepIndex = steps.findIndex((item) => item.step === step.step);
//     const currentStepDone = isStepDone(step.status);

//     if (step.step === "In Review") {
//       if (currentStatus === "In Review") {
//         return {
//           color: "#00E9E7",
//           icon: "circle",
//           text: "In Review",
//           isDone: false,
//         };
//       }
//     }

//     // Handle current status text and icons
//     if (step.step === "Shortlist") {
//       if (currentStatus === "In Review") {
//         return {
//           color: "#00E9E7",
//           icon: "circle",
//           text: "In Review",
//           isDone: false,
//         };
//       }
//       if (currentStatus === "Shortlisted" || isStepDone("Shortlisted")) {
//         return {
//           color: "#00E9E7",
//           icon: "checkmark",
//           text: "Shortlisted",
//           isDone: true,
//         };
//       }
//     }

//     // Handle Interview step
//     if (step.step === "Interview") {
//       if (currentStatus === "Rejected") {
//         return { color: "#FF6B6B", icon: "cancel", text: "Rejected", isDone: false };
//       }
//       if (currentStatus === "Interview In-Progress") {
//         return { color: "#00E9E7", icon: "circle", text: "Interview In-Progress", isDone: false };
//       }
//       if (currentStatus === "Selected" || isStepDone("Selected")) {
//         return { color: "#00E9E7", icon: "checkmark", text: "Interviewed", isDone: true };
//       }
//     }

//     if (step.step === "Documents") {
//       if (currentStatus === "Document Rejected") {
//         return {
//           color: "#FF6B6B",
//           icon: "cancel",
//           text: "Document Rejected",
//           isDone: false,
//         };
//       }
//       if (currentStatus === "Document Verification") {
//         return {
//           color: "#00E9E7",
//           icon: "circle",
//           text: "Document Verification",
//           isDone: false,
//           clickable: true,
//         };
//       }
//       if (currentStatus === "Document Verified" || isStepDone("Document Verified")) {
//         return {
//           color: "#00E9E7",
//           icon: "checkmark",
//           text: "Document Verified",
//           isDone: true,
//         };
//       }
//     }

//     // Handle Offer step with special cases
//     if (step.step === "Offer") {
//       if (currentStatus === "Offer Declined") {
//         return {
//           color: "#FF6B6B",
//           icon: "cancel",
//           text: "Offer Declined",
//           isDone: false,
//         };
//       }
//       if (currentStatus === "Offer Revoked" || currentStatus === "Offer Cancelled") {
//         return {
//           color: "#FF6B6B",
//           icon: "cancel",
//           text: currentStatus,
//           isDone: false,
//         };
//       }
//       switch (currentStatus) {
//         case "Offer Released":
//         case "Offer Revised":
//           return {
//             color: "#00E9E7",
//             icon: "circle",
//             text: "Offer Received",
//             isDone: false,
//             clickable: true,
//           };
//         case "Offer Accepted":
//           return {
//             color: "#00E9E7",
//             icon: "checkmark",
//             text: "Offer Accepted",
//             isDone: true,
//           };
//       }
//     }

//     // Handle previous steps when offer is declined
//     if (currentStatus === "Offer Declined") {
//       if (stepIndex <= 1) {
//         // First two steps (Shortlist and Interview)
//         return {
//           color: "#00E9E7",
//           icon: "checkmark",
//           text: step.done,
//           isDone: true,
//         };
//       }
//     }

//     // Handle Join step
//     if (step.step === "Join" && currentStatus === "Joined") {
//       return {
//         color: "#00E9E7",
//         icon: "checkmark",
//         text: "Joined",
//         isDone: true,
//       };
//     }

//     // Default state for incomplete steps
//     if (!currentStepDone) {
//       return {
//         color: "gray",
//         icon: "circle",
//         text: step.step,
//         isDone: false,
//       };
//     }

//     // Completed steps
//     return {
//       color: "#00E9E7",
//       icon: "checkmark",
//       text: step.done,
//       isDone: true,
//     };
//   };

//   const changeStatus = async (newStatus) => {
//     const payload = {
//       application_id: applicant?.id,
//       status: newStatus,
//     };

//     try {
//       const statusResponse = await dispatch(
//         changeJobApplicationStatus(payload)
//       ).unwrap();
//       if (statusResponse) {
//         setLocalStatus(newStatus);
//         setConfirmModal(false);
//         // Refresh both histories after status change
//         await Promise.all([
//           dispatch(getApplicantHistory()),
//           dispatch(getApplicationStatusHistory({ id: applicant.id })),
//         ]);
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       // Add error handling here - maybe show an error message to user
//       setTitle("Error");
//       setMessage("Failed to update status. Please try again.");
//       setVisible(true);
//     }
//   };

//   const onStatusClick = (step, stepStatus) => {
//     // Handle Interview stage
//     if (currentStatus === "Interview In-Progress" && step === "Interview") {
//       setTitle("Interview Scheduled");
//       setMessage(
//         "Your interview has been scheduled. Please check your email for details."
//       );
//       setVisible(true);
//       return;
//     }

//     // Handle Selected status
//     if (currentStatus === "Selected" && step === "Interview") {
//       setTitle("Interview Completed");
//       setMessage("You have successfully completed the interview process.");
//       setVisible(true);
//       return;
//     }

//     // Handle Offer stage
//     if (
//       (currentStatus === "Offer Released" ||
//         currentStatus === "Offer Revised") &&
//       step === "Offer"
//     ) {
//       const offerLetterFile = offerLetters?.find(

//         (item) =>

//           item?.application_id == applicant?.id && item?.offer_letter_file
//       )?.offer_letter_file;
//       console.log("offerLetterFile", offerLetterFile)

//       if (!offerLetterFile) {
//         setTitle("Offer Letter Not Available");
//         setMessage("The offer letter is not available at the moment.");
//         setVisible(true);
//         return;
//       }

//       dispatch(getOfferLetter(applicant?.id))
//         .then(() => {
//           navigate(`/view-applicant-offer-letter/${applicant?.id}`, {
//             state: {
//               applicant,
//               showActions: true,
//             },
//           });
//         })
//         .catch((err) => {
//           console.error("Error fetching offer letter:", err);
//           setTitle("Error");
//           setMessage("Unable to fetch offer letter. Please try again later.");
//           setVisible(true);
//         });

//       return;
//     }

//     // Handle Offer Accepted
//     if (currentStatus === "Offer Accepted" && step === "Offer") {
//       setTitle("Offer Accepted");
//       setMessage("You have accepted the offer. The next step is joining.");
//       setVisible(true);
//       return;
//     }

//     // Handle Joined status
//     if (currentStatus === "Joined" && step === "Join") {
//       setTitle("Joined");
//       setMessage(
//         "Congratulations! You have successfully joined the organization."
//       );
//       setVisible(true);
//       return;
//     }

//     // For steps that are not yet reached
//     if (!isStepDone(stepStatus)) {
//       setTitle("Step Pending");
//       setMessage(
//         "This step is not yet available. Please wait for the recruiter to proceed."
//       );
//       setVisible(true);
//       return;
//     }

//     // For completed steps
//     setTitle("Step Completed");
//     setMessage(`You have completed the ${step} stage.`);
//     setVisible(true);
//   };

//   const getProgressWidth = (steps, currentStatus, history) => {
//     if (currentStatus === "Document Rejected") {
//       // Calculate progress up to Documents step but don't mark it as complete
//       const completedSteps = steps.filter((step, index) =>
//         isStepDone(step.status) && index <= 2 // Only up to Offer step
//       ).length;
//       return (completedSteps / steps.length) * 100;
//     }
//     const completedSteps = steps?.filter((step) =>
//       isStepDone(step.status)
//     ).length;
//     return (completedSteps / steps.length) * 100;
//   };

//   return (
//     <>
//       <Box sx={{ position: "relative", width: "100%", padding: "5px" }}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "35%",
//             left: "15%",
//             width: "70%",
//             height: "2px",
//             background: `linear-gradient(to right, 
//               #00E9E7 ${getProgressWidth(
//               steps,
//               currentStatus,
//               applicantHistroy
//             )}%, 
//               rgba(128, 128, 128, 0.5) ${getProgressWidth(
//               steps,
//               currentStatus,
//               applicantHistroy
//             )}%
//             )`,
//             zIndex: 0,
//           }}
//         />

//         <Box
//           display="flex"
//           flexDirection="row"
//           justifyContent="space-around"
//           width="100%"
//         >
//           {steps?.map((item, index) => (
//             <Box
//               key={index}
//               display="flex"
//               flexDirection="column"
//               alignItems="center"
//               sx={{ flex: 1 }}
//             >
//               <IconButton
//                 onClick={() => onStatusClick(item.step, item.status)}
//                 sx={{
//                   bgcolor: getStep(item).color,
//                   width: { xs: 30, sm: 35, md: 35 },
//                   height: { xs: 30, sm: 35, md: 35 },
//                   mb: 1,
//                   cursor: getStep(item).clickable ? "pointer" : "default",
//                   "&:hover": {
//                     bgcolor: getStep(item).clickable
//                       ? getStep(item).color + "DD"
//                       : getStep(item).color,
//                   },
//                   "& svg": {
//                     fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.6rem" },
//                   },
//                 }}
//               >
//                 {getStep(item).icon === "cancel" ? (
//                   <CancelIcon sx={{ color: "white" }} />
//                 ) : getStep(item).icon === "checkmark" ? (
//                   <CheckCircleIcon sx={{ color: "white" }} />
//                 ) : (
//                   <RadioButtonUncheckedIcon sx={{ color: "white" }} />
//                 )}
//               </IconButton>

//               <Typography
//                 sx={{
//                   fontSize: { xs: 10, sm: 10, md: 10 }, // Responsive font size
//                   fontWeight: "bold",
//                   color: textColor,
//                   textAlign: "center",
//                 }}
//               >
//                 {isStepDone(item?.status) ? item.done : item.step}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       <OkModal
//         visible={visible}
//         title={title}
//         message={message}
//         onOkPress={() => setVisible(false)}
//       />

//       <ConfirmationModal
//         visible={confirmModal}
//         title={title}
//         message={message}
//         confirmButtonText="Accept Offer"
//         cancelButtonText="Decline Offer"
//         cancelButtonColor="#FF6B6B"
//         onClosePress={() => setConfirmModal(false)}
//         onCancelPress={() => changeStatus("Offer Declined")}
//         onConfirmPress={() => changeStatus("Offer Accepted")}
//       />
//     </>
//   );
// };

// export default ApplicationTrackerforApplicant;



import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch } from "react-redux";
import {
  changeJobApplicationStatus,
  getApplicantHistory,
  getApplicationStatusHistory,
  getOfferLetter,
} from "../../../../Redux/Reducers/JobReducer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useSelector } from "react-redux";
import OkModal from "./okModal";
import ConfirmationModal from "./ConfirmationModal";
import { useNavigate } from "react-router-dom";

const ApplicationTrackerforApplicant = ({ applicant, textColor = "gray" }) => {
  console.log("applicantMMMMMM", applicant)
  const dispatch = useDispatch();
  const [statusModal, setStatusModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [nextStatus, setNextStatus] = useState("");
  const [localStatus, setLocalStatus] = useState(applicant?.application_status);
  const history = useSelector((state) => state?.jobs?.applicationStatusHistory) || [];
  const ApplicantsPage = useSelector((state) => state?.jobs?.appliedJobs) || [];
  const applicantHistroy = ApplicantsPage?.appliedJobs;
  const offerLetters = useSelector((state) => state?.jobs?.OfferLetters) || [];
  const navigate = useNavigate();

  console.log("applicantHistroy", applicantHistroy)
  console.log("currentStatus", localStatus)

  useEffect(() => {
    setLocalStatus(applicant?.application_status);
  }, [applicant?.application_status]);

  const currentStatus = localStatus;

  const steps = [
    { step: "In Review", status: "Shortlisted", done: "Shortlisted" },
    {
      step: "Interview",
      status: "Selected",
      done: "Interviewed",
      intermediateStatuses: ["Interview In-Progress"],
    },
    {
      step: "Offer",
      status: "Offer Accepted",
      done: "Offer Accepted",
      intermediateStates: ["Offer Released", "Offer Revised", "Offer Re-released"],
    },
    {
      step: "Documents",
      status: "Document Verification",
      done: "Document Verified",
      intermediateStates: ["Document Rejected"],
    },
    { step: "Join", status: "Joined", done: "Joined" },
  ];

  const allPositiveStatus = [
    "In Review",
    "Shortlisted",
    "Interview In-Progress",
    "Selected",
    "Offer Released",
    "Offer Revised",
    "Offer Re-released",
    "Offer Accepted",
    "Document Verification",
    "Document Verified",
    "Joined",
  ];

  const isStepDone = (stepStatus) => {
    if (!applicantHistroy?.length) return false;

    const currentApplication = applicantHistroy.find(
      (app) => app.id === applicant.id
    );
    if (!currentApplication) return false;

    const currentAppStatus = currentApplication.application_status;

    // Handle Rejected status - treat as completed up to the rejection point
    if (currentAppStatus === "Rejected") {
      if (stepStatus === "Shortlisted") return true;
      if (stepStatus === "Selected") return false; // Not completed if rejected
      return false;
    }

    // Handle Document Rejected - treat Document Verification as done but not Document Verified
    if (currentAppStatus === "Document Rejected") {
      if (stepStatus === "Document Verification") return true;
      if (stepStatus === "Document Verified") return false;
      return stepStatus === "Shortlisted" || stepStatus === "Selected" || stepStatus === "Offer Accepted";
    }

    // Handle Document Verified - mark as complete
    if (currentAppStatus === "Document Verified") {
      // Only mark steps up to Documents as done
      const documentStepIndex = allPositiveStatus.indexOf("Document Verified");
      const currentStepIndex = allPositiveStatus.indexOf(stepStatus);
      return currentStepIndex <= documentStepIndex;
    }

    // Handle Joined - only mark as complete when status is exactly "Joined"
    if (currentAppStatus === "Joined") {
      // All steps including Join are complete
      const joinStepIndex = allPositiveStatus.indexOf("Joined");
      const currentStepIndex = allPositiveStatus.indexOf(stepStatus);
      return currentStepIndex <= joinStepIndex;
    }

    const stepIndex = allPositiveStatus.indexOf(stepStatus);
    const currentStatusIndex = allPositiveStatus.indexOf(currentAppStatus);

    return stepIndex <= currentStatusIndex;
  };

  // const getStep = (step) => {
  //   const stepIndex = steps.findIndex((item) => item.step === step.step);
  //   const currentStepDone = isStepDone(step.status);

  //   // Handle In Review step
  //   if (step.step === "In Review") {
  //     if (currentStatus === "In Review") {
  //       return {
  //         color: "#00E9E7",
  //         icon: "circle",
  //         text: "In Review",
  //         isDone: false,
  //       };
  //     }
  //   }

  //   // Handle Shortlist step
  //   if (step.step === "Shortlist") {
  //     if (currentStatus === "In Review") {
  //       return {
  //         color: "#00E9E7",
  //         icon: "circle",
  //         text: "In Review",
  //         isDone: false,
  //       };
  //     }
  //     if (currentStatus === "Shortlisted" || isStepDone("Shortlisted")) {
  //       return {
  //         color: "#00E9E7",
  //         icon: "checkmark",
  //         text: "Shortlisted",
  //         isDone: true,
  //       };
  //     }
  //   }

  //   // Handle Interview step
  //   if (step.step === "Interview") {
  //     if (currentStatus === "Rejected") {
  //       return { color: "#FF6B6B", icon: "cancel", text: "Rejected", isDone: false };
  //     }
  //     if (currentStatus === "Interview In-Progress") {
  //       return { color: "#00E9E7", icon: "circle", text: "Interview In-Progress", isDone: false };
  //     }
  //     if (currentStatus === "Selected" || isStepDone("Selected")) {
  //       return { color: "#00E9E7", icon: "checkmark", text: "Interviewed", isDone: true };
  //     }
  //   }

  //   // Handle Offer step
  //   if (step.step === "Offer") {
  //     if (currentStatus === "Offer Declined") {
  //       return {
  //         color: "#FF6B6B",
  //         icon: "cancel",
  //         text: "Offer Declined",
  //         isDone: false,
  //       };
  //     }
  //     if (currentStatus === "Offer Revoked" || currentStatus === "Offer Cancelled") {
  //       return {
  //         color: "#FF6B6B",
  //         icon: "cancel",
  //         text: currentStatus,
  //         isDone: false,
  //       };
  //     }
  //     switch (currentStatus) {
  //       case "Offer Released":
  //       case "Offer Revised":
  //       case "Offer Re-released":
  //         return {
  //           color: "#00E9E7",
  //           icon: "circle",
  //           text: "Offer Received",
  //           isDone: false,
  //           clickable: true,
  //         };
  //       case "Offer Accepted":
  //         return {
  //           color: "#00E9E7",
  //           icon: "checkmark",
  //           text: "Offer Accepted",
  //           isDone: true,
  //         };
  //     }
  //   }

  //   // Handle Documents step - FIXED
  //   if (step.step === "Documents") {
  //     // Case 1: Document Verified (Success)
  //     if (currentStatus === "Document Verified" || isStepDone("Document Verified")) {
  //       return {
  //         color: "#00E9E7",
  //         icon: "checkmark",
  //         text: "Document Verified",
  //         isDone: true,
  //       };
  //     }

  //     // Case 2: Document Rejected (Failure)
  //     if (currentStatus === "Document Rejected") {
  //       return {
  //         color: "#FF6B6B",
  //         icon: "cancel",
  //         text: "Document Rejected",
  //         isDone: false,
  //         clickable: true, // Make it clickable to show rejection message
  //       };
  //     }

  //     // Case 3: Document Verification in Progress
  //     if (currentStatus === "Document Verification") {
  //       return {
  //         color: "#00E9E7",
  //         icon: "circle",
  //         text: "Document Verification",
  //         isDone: false,
  //         clickable: true,
  //       };
  //     }

  //     // Case 4: Not yet reached Documents step
  //     if (!currentStepDone) {
  //       return {
  //         color: "gray",
  //         icon: "circle",
  //         text: "Documents",
  //         isDone: false,
  //       };
  //     }
  //   }

  //   // Handle Join step
  //   if (step.step === "Join") {
  //     if (currentStatus === "Joined") {
  //       return {
  //         color: "#00E9E7",
  //         icon: "checkmark",
  //         text: "Joined",
  //         isDone: true,
  //       };
  //     }
  //   }

  //   // Default state for incomplete steps
  //   if (!currentStepDone) {
  //     return {
  //       color: "gray",
  //       icon: "circle",
  //       text: step.step,
  //       isDone: false,
  //     };
  //   }

  //   // Completed steps
  //   return {
  //     color: "#00E9E7",
  //     icon: "checkmark",
  //     text: step.done,
  //     isDone: true,
  //   };
  // };

  const getStep = (step) => {
    const stepIndex = steps.findIndex((item) => item.step === step.step);
    const currentStepDone = isStepDone(step.status);

    // Handle In Review step
    if (step.step === "In Review") {
      if (currentStatus === "In Review") {
        return {
          color: "#00E9E7",
          icon: "circle",
          text: "In Review",
          isDone: false,
        };
      }
    }

    // Handle Shortlist step
    if (step.step === "Shortlist") {
      if (currentStatus === "In Review") {
        return {
          color: "#00E9E7",
          icon: "circle",
          text: "In Review",
          isDone: false,
        };
      }
      if (currentStatus === "Shortlisted" || isStepDone("Shortlisted")) {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Shortlisted",
          isDone: true,
        };
      }
    }

    // Handle Interview step
    if (step.step === "Interview") {
      if (currentStatus === "Rejected") {
        return { color: "#FF6B6B", icon: "cancel", text: "Rejected", isDone: false };
      }
      if (currentStatus === "Interview In-Progress") {
        return { color: "#00E9E7", icon: "circle", text: "Interview In-Progress", isDone: false };
      }
      if (currentStatus === "Selected" || isStepDone("Selected")) {
        return { color: "#00E9E7", icon: "checkmark", text: "Interviewed", isDone: true };
      }
    }

    // Handle Offer step
    if (step.step === "Offer") {
      if (currentStatus === "Offer Declined") {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: "Offer Declined",
          isDone: false,
        };
      }
      if (currentStatus === "Offer Revoked" || currentStatus === "Offer Cancelled") {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: currentStatus,
          isDone: false,
        };
      }
      switch (currentStatus) {
        case "Offer Released":
        case "Offer Revised":
        case "Offer Re-released":
          return {
            color: "#00E9E7",
            icon: "circle",
            text: "Offer Received",
            isDone: false,
            clickable: true,
          };
        case "Offer Accepted":
          return {
            color: "#00E9E7",
            icon: "checkmark",
            text: "Offer Accepted",
            isDone: true,
          };
      }
    }

    // Handle Documents step - UPDATED
    if (step.step === "Documents") {
      // Case 1: Document Verified (Success)
      if (currentStatus === "Document Verified") {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Document Verified",
          isDone: true,
        };
      }

      // Case 2: Document Verification in Progress OR Document Rejected
      // Both show "Documents Requested" with different colors
      if (currentStatus === "Document Verification") {
        return {
          color: "#00E9E7",
          icon: "circle",
          text: "Documents Requested",
          isDone: false,
          clickable: true,
        };
      }

      if (currentStatus === "Document Rejected") {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: "Documents Requested",
          isDone: false,
          clickable: true,
        };
      }

      // Case 3: Not yet reached Documents step
      if (!currentStepDone) {
        return {
          color: "gray",
          icon: "circle",
          text: "Documents",
          isDone: false,
        };
      }
    }

    // Handle Join step
    if (step.step === "Join") {
      if (currentStatus === "Joined") {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Joined",
          isDone: true,
        };
      }
    }

    // Default state for incomplete steps
    if (!currentStepDone) {
      return {
        color: "gray",
        icon: "circle",
        text: step.step,
        isDone: false,
      };
    }

    // Completed steps
    return {
      color: "#00E9E7",
      icon: "checkmark",
      text: step.done,
      isDone: true,
    };
  };

  const changeStatus = async (newStatus) => {
    const normalizedStatus = newStatus === "Not Joined" ? "Not Joined" : newStatus;
    const payload = {
      application_id: applicant?.id,
      status: normalizedStatus,
    };

    try {
      const statusResponse = await dispatch(
        changeJobApplicationStatus(payload)
      ).unwrap();
      if (statusResponse) {
        setLocalStatus(normalizedStatus);
        setConfirmModal(false);
        await Promise.all([
          dispatch(getApplicantHistory()),
          dispatch(getApplicationStatusHistory({ id: applicant.id })),
        ]);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setTitle("Error");
      setMessage("Failed to update status. Please try again.");
      setVisible(true);
    }
  };

  const onStatusClick = (step, stepStatus) => {
    // Handle Interview stage
    if (currentStatus === "Interview In-Progress" && step === "Interview") {
      setTitle("Interview Scheduled");
      setMessage(
        "Your interview has been scheduled. Please check your email for details."
      );
      setVisible(true);
      return;
    }

    // Handle Selected status
    if (currentStatus === "Selected" && step === "Interview") {
      setTitle("Interview Completed");
      setMessage("You have successfully completed the interview process.");
      setVisible(true);
      return;
    }

    // Handle Offer stage
    if (
      (currentStatus === "Offer Released" ||
        currentStatus === "Offer Revised" ||
        currentStatus === "Offer Re-released") &&
      step === "Offer"
    ) {
      const offerLetterFile = offerLetters?.find(
        (item) =>
          item?.application_id == applicant?.id && item?.offer_letter_file
      )?.offer_letter_file;
      console.log("offerLetterFile", offerLetterFile)

      if (!offerLetterFile) {
        setTitle("Offer Letter Not Available");
        setMessage("The offer letter is not available at the moment.");
        setVisible(true);
        return;
      }

      dispatch(getOfferLetter(applicant?.id))
        .then(() => {
          navigate(`/view-applicant-offer-letter/${applicant?.id}`, {
            state: {
              applicant,
              showActions: true,
            },
          });
        })
        .catch((err) => {
          console.error("Error fetching offer letter:", err);
          setTitle("Error");
          setMessage("Unable to fetch offer letter. Please try again later.");
          setVisible(true);
        });

      return;
    }

    // Handle Offer Accepted
    if (currentStatus === "Offer Accepted" && step === "Offer") {
      setTitle("Offer Accepted");
      setMessage("You have accepted the offer. The next step is documents verification.");
      setVisible(true);
      return;
    }

    // Handle Documents stage - FIXED
    if (step === "Documents") {
      // If Document Verification is in progress
      if (currentStatus === "Document Verification") {
        setTitle("Document Verification");
        setMessage("Your documents are being verified. Please check your email for updates.");
        setVisible(true);
        return;
      }

      // If Document Rejected
      if (currentStatus === "Document Rejected") {
        setTitle("Document Rejected");
        setMessage("Your documents have been rejected. Please check your email for details and resubmission instructions.");
        setVisible(true);
        return;
      }

      // If Document Verified
      if (currentStatus === "Document Verified") {
        setTitle("Document Verified");
        setMessage("Your documents have been verified successfully. Proceeding to joining.");
        setVisible(true);
        return;
      }

      // If not yet reached
      setTitle("Step Pending");
      setMessage("This step is not yet available. Please wait for the recruiter to proceed.");
      setVisible(true);
      return;
    }

    // Handle Joined status
    if (currentStatus === "Joined" && step === "Join") {
      setTitle("Joined");
      setMessage(
        "Congratulations! You have successfully joined the organization."
      );
      setVisible(true);
      return;
    }

    // For steps that are not yet reached
    if (!isStepDone(stepStatus)) {
      setTitle("Step Pending");
      setMessage(
        "This step is not yet available. Please wait for the recruiter to proceed."
      );
      setVisible(true);
      return;
    }

    // For completed steps
    setTitle("Step Completed");
    setMessage(`You have completed the ${step} stage.`);
    setVisible(true);
  };

  const getProgressWidth = (steps, currentStatus, history) => {
    if (currentStatus === "Document Rejected") {
      // Calculate progress up to Documents step (Offer step is completed)
      const completedSteps = steps.filter((step) => {
        if (step.step === "Documents") return false; // Don't count Documents as complete
        return isStepDone(step.status);
      }).length;
      return (completedSteps / steps.length) * 100;
    }

    if (currentStatus === "Document Verified") {
      // All steps through Documents are complete
      const completedSteps = steps.filter((step) =>
        isStepDone(step.status)
      ).length;
      return (completedSteps / steps.length) * 100;
    }

    if (currentStatus === "Document Verification") {
      // Documents step is in progress
      const completedSteps = steps.filter((step) => {
        if (step.step === "Documents") return false; // Not complete yet
        return isStepDone(step.status);
      }).length;
      return ((completedSteps + 0.5) / steps.length) * 100; // Half progress for in-progress
    }

    const completedSteps = steps?.filter((step) =>
      isStepDone(step.status)
    ).length;
    return (completedSteps / steps.length) * 100;
  };

  return (
    <>
      <Box sx={{ position: "relative", width: "100%", padding: "5px" }}>
        <Box
          sx={{
            position: "absolute",
            top: "35%",
            left: "15%",
            width: "70%",
            height: "2px",
            background: `linear-gradient(to right, 
              #00E9E7 ${getProgressWidth(
              steps,
              currentStatus,
              applicantHistroy
            )}%, 
              rgba(128, 128, 128, 0.5) ${getProgressWidth(
              steps,
              currentStatus,
              applicantHistroy
            )}%
            )`,
            zIndex: 0,
          }}
        />

        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-around"
          width="100%"
        >
          {steps?.map((item, index) => {
            const stepState = getStep(item);
            return (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{ flex: 1 }}
              >
                <IconButton
                  onClick={() => onStatusClick(item.step, item.status)}
                  sx={{
                    bgcolor: stepState.color,
                    width: { xs: 30, sm: 35, md: 35 },
                    height: { xs: 30, sm: 35, md: 35 },
                    mb: 1,
                    cursor: stepState.clickable ? "pointer" : "default",
                    "&:hover": {
                      bgcolor: stepState.clickable
                        ? stepState.color + "DD"
                        : stepState.color,
                    },
                    "& svg": {
                      fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.6rem" },
                    },
                  }}
                >
                  {stepState.icon === "cancel" ? (
                    <CancelIcon sx={{ color: "white" }} />
                  ) : stepState.icon === "checkmark" ? (
                    <CheckCircleIcon sx={{ color: "white" }} />
                  ) : (
                    <RadioButtonUncheckedIcon sx={{ color: "white" }} />
                  )}
                </IconButton>

                <Typography
                  sx={{
                    fontSize: { xs: 10, sm: 10, md: 10 },
                    fontWeight: "bold",
                    color: stepState.color === "gray" ? textColor : stepState.color,
                    textAlign: "center",
                  }}
                >
                  {stepState.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      <OkModal
        visible={visible}
        title={title}
        message={message}
        onOkPress={() => setVisible(false)}
      />

      <ConfirmationModal
        visible={confirmModal}
        title={title}
        message={message}
        confirmButtonText="Accept Offer"
        cancelButtonText="Decline Offer"
        cancelButtonColor="#FF6B6B"
        onClosePress={() => setConfirmModal(false)}
        onCancelPress={() => changeStatus("Offer Declined")}
        onConfirmPress={() => changeStatus("Offer Accepted")}
      />
    </>
  );
};

export default ApplicationTrackerforApplicant;
